export default "/images/181c3a61639d9924b7818eb6638b5c37.avif";